import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

import type { ButtonProps } from "./types";
import { buttonVariants } from "./variants";

const CustomButton = ({
  className,
  variant,
  size,
  children,
  full,
  iconSize,
  isPending,
  disabled,
  ...props
}: ButtonProps) => {
  const finalVariant = isPending ? "pending" : variant;

  return (
    <Button
      className={cn(
        buttonVariants({ variant: finalVariant, size, full, iconSize }),
        className
      )}
      {...props}
      disabled={Boolean(isPending) || disabled}
    >
      {isPending ? (
        <div className="flex items-center gap-2">
          <Spinner />
          <span>Please wait</span>
        </div>
      ) : (
        children
      )}
    </Button>
  );
};

export default CustomButton;
